import { useRef, useState } from "react";
import { CardVariant } from "../../models/CardVariant";
import { CardCarouselModal, CardCarouselModalProps } from "./CardCarouselModal"
import { MinusIcon, PlusIcon } from "@heroicons/react/24/outline";

export type BuilderCardCarouselModalProps = CardCarouselModalProps & {
    serialQuantities: Record<string, number>,
    onAdd: (variant: CardVariant) => void,
    onRemove: (variant: CardVariant) => void
};

export function BuilderCardCarouselModal(props: BuilderCardCarouselModalProps) {
    const [variant, setVariant] = useState<CardVariant | null>(null);

    return (

        <CardCarouselModal
            isOpen={props.isOpen}
            onOpenChange={props.onOpenChange}
            startingIndex={props.startingIndex}
            variants={props.variants}
            onVariantChange={setVariant}
            format={props.format}
            onKeyDown={(event) => {
                if (event.code === "ArrowUp") {
                    if (variant) {
                        props.onAdd(variant);
                    }

                    return;
                }

                if (event.code === "ArrowDown") {
                    if (variant) {
                        props.onRemove(variant);
                    }

                    return;
                }
            }}
            rightActions={
                <div className="flex flex-col gap-1 z-[200] mb-1">
                    <button
                        aria-label="Add"
                        title="Add"
                        className="theme-dark text-contrast-primary bg-primary hover:bg-secondary disabled:bg-muted disabled:cursor-not-allowed rounded-md p-2 border border-color-border/50"
                        disabled={!variant}
                        onClick={() => {
                            if (variant) {
                                props.onAdd(variant);
                            }
                        }}>
                        <PlusIcon className="w-8 h-8" />
                    </button>
                    <button
                        aria-label="Remove"
                        title="Remove"
                        className="theme-dark text-contrast-primary bg-primary hover:bg-secondary disabled:bg-muted disabled:cursor-not-allowed rounded-md p-2 border border-color-border/50"
                        disabled={!variant}
                        onClick={() => {
                            if (variant) {
                                props.onRemove(variant);
                            }
                        }}>
                        <MinusIcon className="w-8 h-8" />
                    </button>
                    <div className="theme-dark text-contrast-primary bg-primary rounded-md w-full text-center border border-color-border/50 text-5xl font-black select-none self-center">
                        {props.serialQuantities[variant?.serial ?? ""] ?? 0}
                    </div>
                </div>
            } />
    )
}